// profile/getters.ts
import { GetterTree } from 'vuex'
import { UserState } from '@/types/store/user'
import { RootState } from '@/types/store'

export const getters: GetterTree<RootState, RootState> = {
  token: (state): string | undefined => state.user.token,
  id: (state): number => state.user.id,
  avatar: (state): string => state.user.avatar,
  name: (state): string => state.user.name,
  nickname: (state): string => state.user.nickname,
  phone: (state): string => state.user.phone,
  status: (state): string => state.user.status,
  roles: (state): string[] => state.user.roles,
  user: (state): UserState  => state.user,
  userRole(state): string {
    const { accounttype } = state.user.userInfo
    let role = '1'
    switch (accounttype && accounttype.toLowerCase()) {
      case 'admin':
        role += '|0'
        break
      case 'normal':
        role += '|1'
        break
    }

    return role
  },
  menus(state): any {
    const resources = state.user.auths
    let menus = {}
    if (resources) {
      for (let res of resources) {
        if (res.resourceType !== 'PAGE') continue
        let arr = res.resourceUrl.split('/'),
          obj: any = menus

        for (let r of arr) {
          if (r) {
            r = r.replace(/-\w/g, val => val[1].toUpperCase())

            if (!obj[r]) {
              obj[r] = Object.create(null)
            }
            obj = obj[r]
          }
        }
      }
    }
    return menus
  }
}
